module.exports = __webpack_public_path__ + "media/military/military_rotc_btn_hover-ceb564e6.png";